export enum CompanyTypeEnum {
    BROKER = 400,
    CUSTOMER = 300,
    SYSTEM = 100,
    CLIENT = 200
}